import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.check');
import { OnInit, ChangeDetectorRef, NgZone } from "@angular/core";
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-check',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.check/view.scss */
/* src/app/page.check/view.scss: no such file or directory */`],
})
export class PageCheckComponent implements OnInit {
  public items: any[] = [];
  public selectedQA: any = null;
  public activeTab: string = "pending"; // ✅ 기본 탭: 검수 대기 목록
  public history: any[] = [];

  constructor(@Inject( Service)     public service: Service,@Inject( ChangeDetectorRef)     private cdr: ChangeDetectorRef,@Inject( NgZone  )     private zone: NgZone  ) { }

  public async ngOnInit() {
    await this.service.init();

    const now = new Date().toLocaleString("ko-KR");

    this.items = [
      {
        title: "임상 한의학 종합DB",
        type: "자동",
        qas: [
          {
            type: "practice",
            level: "easy",
            question: "합곡혈의 주치증은?",
            answer: "합곡혈은 제1, 2 장골 사이에 위치하며...",
            date: now,
          },
          {
            type: "diagnosis",
            level: "hard",
            question: "양명병의 경증과 부증의 차이는?",
            answer: "양명병의 경증과 부증의 차이로는...",
            date: now,
          },
        ],
      },
      {
        title: "황제내경 벡터DB",
        type: "수동",
        qas: [
          {
            type: "practice",
            level: "easy",
            question: "황제내경에서 말하는 상고시대 양생법은?",
            answer: "황제내경은 양생을 위해 음양의 조화를 강조합니다.",
            date: now,
          },
        ],
      },
      {
        title: "황제내경 벡터DB",
        type: "수동",
        qas: [
          {
            type: "practice",
            level: "easy",
            question: "황제내경에서 말하는 상고시대 양생법은?",
            answer: "황제내경은 양생을 위해 음양의 조화를 강조합니다.",
            date: now,
          },
        ],
      },
      {
        title: "황제내경 벡터DB",
        type: "수동",
        qas: [
          {
            type: "practice",
            level: "easy",
            question: "황제내경에서 말하는 상고시대 양생법은?",
            answer: "황제내경은 양생을 위해 음양의 조화를 강조합니다.",
            date: now,
          },
        ],
      },
      {
        title: "황제내경 벡터DB",
        type: "수동",
        qas: [
          {
            type: "practice",
            level: "easy",
            question: "황제내경에서 말하는 상고시대 양생법은?",
            answer: "황제내경은 양생을 위해 음양의 조화를 강조합니다.",
            date: now,
          },
        ],
      },
      {
        title: "황제내경 벡터DB",
        type: "수동",
        qas: [
          {
            type: "practice",
            level: "easy",
            question: "황제내경에서 말하는 상고시대 양생법은?",
            answer: "황제내경은 양생을 위해 음양의 조화를 강조합니다.",
            date: now,
          },
        ],
      },
      {
        title: "황제내경 벡터DB",
        type: "수동",
        qas: [
          {
            type: "practice",
            level: "easy",
            question: "황제내경에서 말하는 상고시대 양생법은?",
            answer: "황제내경은 양생을 위해 음양의 조화를 강조합니다.",
            date: now,
          },
        ],
      },
    ];

    this.cdr.detectChanges();
  }

  public onQASelected(qa: any) {
    console.log("💡 선택된 QA:", qa);
    this.zone.run(() => {
      this.selectedQA = qa;
      this.cdr.detectChanges();
    });
  }

  public setActiveTab(tab: string) {
    this.zone.run(() => {
      this.activeTab = tab;
      this.selectedQA = null;
      console.log("🔁 현재 탭:", this.activeTab);
      this.cdr.detectChanges();
    });
  }
    // ✅ 검수 기록 추가 (승인 / 반려)
  public addToHistory(result: any) {
    this.zone.run(() => {
      this.history.unshift({
        status: result.status,
        rating: result.rating,
        question: result.question,
        comment: result.comment,
        title: "검수 기록 - " + new Date().toLocaleString("ko-KR"),
        category: result.type,
        date: new Date().toLocaleString("ko-KR"),
      });
      console.log("📝 검수 이력 추가됨:", this.history);
      this.cdr.detectChanges();
    });
  }
}

export default PageCheckComponent;